import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import { useEffect } from 'react';

export default function Cookies() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
            Política de Cookies
          </h1>

          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Información sobre las cookies utilizadas en esta web
              </h2>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                ¿Qué es una cookie?
              </h3>
              <p>
                Una cookie es un pequeño archivo de información que el servidor envía a su navegador y permite almacenar y recuperar información para ofrecerle una mejor experiencia de usuario y/o realizar estadísticas anónimas de navegación.
              </p>
            </section>

            <section>
              <p>
                El presente sitio web utiliza cookies para llevar a cabo determinadas funciones que son consideradas imprescindibles para el correcto funcionamiento y visualización del mismo. También utilizamos cookies para el análisis de su navegación dentro del sitio web, con la finalidad de comprender como navegan los usuarios dentro de la web y poder mejorarla tras analizar dicha información. En ningún caso se utilizarán las cookies para recoger información de carácter personal.
              </p>
            </section>

            <section>
              <p className="font-semibold">
                Para utilizar el presente sitio web en toda su funcionalidad, debe aceptar la instalación de estas cookies en su dispositivo.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                ¿Qué cookies utilizamos?
              </h3>
              <p className="mb-4">Los tipos de cookies que utilizamos son:</p>

              <div className="space-y-4 pl-4">
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Cookies técnicas:</h4>
                  <p>
                    Estas cookies son necesarias para el correcto uso de la página web, permitiendo el acceso a secciones que cuentan con filtros de seguridad. Sin estas cookies, muchos de los servicios disponibles no estarían operativos.
                  </p>
                </div>

                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Cookies de análisis:</h4>
                  <p>
                    Son aquéllas que, bien tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del sitio web. Para ello se analiza su navegación en nuestra página web con el fin de mejorar el servicio que prestamos así como nuestra oferta de productos. Para este análisis utilizamos el Servicio Google Analytics, de Google Inc.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <p>
                Al utilizar nuestros servicios acepta la utilización de las cookies. Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su dispositivo. Por favor, consulte las instrucciones y manuales de su navegador para ampliar esta información.
              </p>
            </section>

            <section>
              <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                <h4 className="font-bold text-gray-900 mb-4">
                  Configuración de cookies por navegador:
                </h4>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <span className="font-semibold min-w-[140px] text-gray-900">Google Chrome</span>
                    <a 
                      href="https://support.google.com/chrome/answer/95647?hl=es" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-teal-600 hover:text-teal-700 break-all"
                    >
                      https://support.google.com/chrome/answer/95647?hl=es
                    </a>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold min-w-[140px] text-gray-900">Firefox</span>
                    <a 
                      href="http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-teal-600 hover:text-teal-700 break-all"
                    >
                      http://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we
                    </a>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold min-w-[140px] text-gray-900">Internet Explorer</span>
                    <a 
                      href="http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-8" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-teal-600 hover:text-teal-700 break-all"
                    >
                      http://windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie=ie-8
                    </a>
                  </div>
                  <div className="flex items-start">
                    <span className="font-semibold min-w-[140px] text-gray-900">Safari</span>
                    <span className="text-gray-700">
                      Puedes obtener información en el menú de Ayuda del navegador
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
